import React, { useRef, useEffect } from 'react';
import { useTabs } from './TabContext';
import CloseIcon from '@mui/icons-material/Close';
import HomeIcon from '@mui/icons-material/Home';
import './TabBar.css';

const TabBar = () => {
  const { tabs, activeTab, switchTab, closeTab } = useTabs();
  const scrollRef = useRef(null);
  const activeRef = useRef(null);

  // Scroll active tab into view
  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }, [activeTab]);

  return (
    <div className="tabbar-root">
      <div className="tabbar-scroll" ref={scrollRef}>
        {tabs.map(tab => (
          <div
            key={tab.path}
            ref={tab.path === activeTab ? activeRef : null}
            className={`tabbar-tab ${tab.path === activeTab ? 'tabbar-tab--active' : ''}`}
            onClick={() => switchTab(tab.path)}
            title={tab.label}
          >
            {tab.path === '/Home' && (
              <HomeIcon sx={{ fontSize: 13, mr: 0.5, flexShrink: 0 }} />
            )}
            <span className="tabbar-tab-label">{tab.label}</span>
            {tabs.length > 1 && tab.path !== '/Home' && (
              <button
                className="tabbar-close"
                onClick={(e) => closeTab(tab.path, e)}
                title="Close"
              >
                <CloseIcon sx={{ fontSize: 11 }} />
              </button>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default TabBar;
